import { Department } from "../Department/Department.type";
import { Project } from "../Project/Project.type";
import { Store } from "../Store/Store.type";
import { Supplier } from "../Supplier/Supplier.type";
import { ApiCallState } from "../Utils";

export type FixedAssetRegistry = {
  id: number;
  user_id: number;

  po_no?: string | null;
  name: string;
  code: string;
  gc_date: Date | string;
  type: string;
  store_id?: number | null;
  project_id?: number | null;
  department_id?: number | null;
  supplier_id: number;
  supplier_invoice: string;
  pad_ref?: string | null;
  waybill_no?: string | null;
  is_void: boolean;

  readonly createdAt: Date;
  readonly updatedAt: Date;

  store?: Store;
  project?: Project;
  department?: Department;
  supplier?: Supplier;
};

export type FixedAssetRegistryStateTypes = {
  fetchAll: ApiCallState<FixedAssetRegistry[]>;
  fetchOne: ApiCallState<FixedAssetRegistry | {}>;
};

export const FixedAssetRegistryActionTypes = {
  FETCH_ALL_FIXED_ASSET_REGISTRY: "FETCH_ALL_FIXED_ASSET_REGISTRY",
  FETCH_ALL_FIXED_ASSET_REGISTRY_RESET: "FETCH_ALL_FIXED_ASSET_REGISTRY_RESET",
  FETCH_ALL_FIXED_ASSET_REGISTRY_FAILURE:
    "FETCH_ALL_FIXED_ASSET_REGISTRY_FAILURE",
  FETCH_ALL_FIXED_ASSET_REGISTRY_SUCCESS:
    "FETCH_ALL_FIXED_ASSET_REGISTRY_SUCCESS",

  FETCH_ONE_FIXED_ASSET_REGISTRY: "FETCH_ONE_FIXED_ASSET_REGISTRY",
  FETCH_ONE_FIXED_ASSET_REGISTRY_RESET: "FETCH_ONE_FIXED_ASSET_REGISTRY_RESET",
  FETCH_ONE_FIXED_ASSET_REGISTRY_FAILURE:
    "FETCH_ONE_FIXED_ASSET_REGISTRY_FAILURE",
  FETCH_ONE_FIXED_ASSET_REGISTRY_SUCCESS:
    "FETCH_ONE_FIXED_ASSET_REGISTRY_SUCCESS",
};
